import {
  ProfileButtonShape,
  ProfileHeaderStyle,
  ProfileLayout,
  ProfileTheme,
} from '@up2stay/up2promo-api-client';
import { z } from 'zod';

/** Zod schema for the profile template detail editor form. */
export const templateDetailFormSchema = z.object({
  jobTitle: z.string().max(30).optional().nullable(),
  company: z.string().max(30).optional().nullable(),
  location: z.string().max(30).optional().nullable(),
  showProfileImage: z.boolean().optional(),
  showUp2promoBranding: z.boolean().optional(),
  accentColor: z.string().nullable().optional(),
  layout: z.nativeEnum(ProfileLayout).optional(),
  theme: z.nativeEnum(ProfileTheme).optional(),
  headerStyle: z.nativeEnum(ProfileHeaderStyle).optional(),
  headerImage: z
    .object({
      id: z.string().min(1),
      path: z.string().optional(),
    })
    .nullable()
    .optional(),
  buttonShape: z.nativeEnum(ProfileButtonShape).nullable().optional(),
  language: z.enum(['auto', 'de', 'en']).optional(),
  visibility: z.enum(['private', 'unlisted']).optional(),
  leadFormEnabled: z.boolean().optional(),
  leadFormVisibilityMode: z.enum(['off', 'manual', 'auto_open']).optional(),
  leadFormAutoOpenDelay: z.number().min(0).max(15).optional().nullable(),
  leadsAutoShareWithWorkspace: z.boolean().optional(),
});
